import { useCallback } from "react";

/**
 * A hook that returns a function to programmatically focus an HTML element,
 * adding a "focus-visible" class for styling purposes.
 * This allows to simulate keyboard focus styles when focusing elements via code.
 */
export function useProgrammaticFocus() {
  const programmaticFocus = useCallback(
    (el: HTMLElement | null | undefined) => {
      if (!el) return;

      el.focus();
      el.classList.add("focus-visible");

      const remove = () => {
        el.classList.remove("focus-visible");
        el.removeEventListener("blur", remove);
      };

      el.addEventListener("blur", remove);
    },
    [],
  );

  return programmaticFocus;
}
